<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, RouterLink } from 'vue-router'
import { Breadcrumb, BreadcrumbItem } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import { useBreadcrumbs } from '../composables/useBreadcrumbs'
import { usePageHeader } from '@/composables/usePageHeader'

const { t } = useI18n()
const route = useRoute()
const { breadcrumbs } = useBreadcrumbs()
const { headerActionsComponent, headerActionsProps } = usePageHeader()

const pageTitle = computed(() => {
  const titleKey = route.meta.titleKey as string | undefined
  return titleKey ? t(titleKey) : String(route.meta.title || 'Overview')
})
</script>

<template>
 <section class="crm-page-header">
  <div class="crm-page-header__title">
   <Breadcrumb>
    <BreadcrumbItem v-for="crumb in breadcrumbs" :key="crumb.label">
     <RouterLink v-if="crumb.to" :to="crumb.to">{{ crumb.label }}</RouterLink>
     <span v-else>{{ crumb.label }}</span>
    </BreadcrumbItem>
   </Breadcrumb>
   <h1>{{ pageTitle }}</h1>
  </div>
  <div v-if="headerActionsComponent" class="crm-page-header__actions">
   <component :is="headerActionsComponent" v-bind="headerActionsProps || {}" />
  </div>
 </section>
</template>
